import CustomTooltip from '../../../../Utils/CustomTooltip/CustomTooltip';
import './CheckboxGroup.scss';
import { TCheckboxGroupProps } from './CheckboxGroup.type';

const CheckboxGroup: React.FC<TCheckboxGroupProps> = (props: TCheckboxGroupProps) => {
  const {
    items,
    userSelectedValue,
    defaultValue,
    handleChange,
    type,
    slug,
    isAdvanceSearch,
    validationError = false,
  } = props;

  const createCheckbox = (index: number, option: any) => {
    return (
      <>
        <input
          type="checkbox"
          id={index.toString()}
          name={option?.OPTION_VALUE}
          value={option?.OPTION_VALUE}
          checked={(userSelectedValue || defaultValue)?.includes(option?.OPTION_VALUE)}
          className={`checkbox-input ${
            (userSelectedValue || defaultValue)?.includes(option?.OPTION_VALUE) ? 'checked' : ''
          }`}
          onChange={() => handleChange(type, slug, option?.OPTION_VALUE, defaultValue)}
        />
        <label htmlFor={index.toString()}>{option?.OPTION_TITLE}</label>
      </>
    );
  };

  return (
    <div className="Checkbox_Group">
      {items?.map((option: any, index: number) => (
        <div
          key={option?.OPTION_VALUE}
          className={`Checkbox_Option ${isAdvanceSearch ? 'advanceCss' : ''}`}
        >
          {isAdvanceSearch ? (
            <CustomTooltip message={'Coming Soon'}>{createCheckbox(index, option)}</CustomTooltip>
          ) : (
            createCheckbox(index, option)
          )}
        </div>
      ))}
    </div>
  );
};

export default CheckboxGroup;
